// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,optimize_code_size,server_grpc1,long_type_number
// @generated from protobuf file "aware_proto/proto/Event.proto" (package "aware", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Place } from "./Location";
import { DataContext } from "./Person";
import { AwareSpaceLocation } from "./Location";
import { TransitMode } from "./Activity";
import { Geolocation } from "./Location";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf enum aware.Event.EventType
 */
export var Event_EventType;
(function (Event_EventType) {
    /**
     * @generated from protobuf enum value: UnknownEventType = 0;
     */
    Event_EventType[Event_EventType["UnknownEventType"] = 0] = "UnknownEventType";
    /**
     * @generated from protobuf enum value: CalendarEvent = 1;
     */
    Event_EventType[Event_EventType["CalendarEvent"] = 1] = "CalendarEvent";
    /**
     * @generated from protobuf enum value: Preparation = 2;
     */
    Event_EventType[Event_EventType["Preparation"] = 2] = "Preparation";
    /**
     * @generated from protobuf enum value: Transit = 3;
     */
    Event_EventType[Event_EventType["Transit"] = 3] = "Transit";
    /**
     * @generated from protobuf enum value: SuggestedActivity = 4;
     */
    Event_EventType[Event_EventType["SuggestedActivity"] = 4] = "SuggestedActivity";
    /**
     * @generated from protobuf enum value: EarlyArrival = 5;
     */
    Event_EventType[Event_EventType["EarlyArrival"] = 5] = "EarlyArrival";
    /**
     * @generated from protobuf enum value: Reminder = 6;
     */
    Event_EventType[Event_EventType["Reminder"] = 6] = "Reminder";
    /**
     * ...
     *
     * @generated from protobuf enum value: Inferred = 7;
     */
    Event_EventType[Event_EventType["Inferred"] = 7] = "Inferred";
})(Event_EventType || (Event_EventType = {}));
/**
 * @generated from protobuf enum aware.EventOperation.EventOperationType
 */
export var EventOperation_EventOperationType;
(function (EventOperation_EventOperationType) {
    /**
     * @generated from protobuf enum value: Undefined = 0;
     */
    EventOperation_EventOperationType[EventOperation_EventOperationType["Undefined"] = 0] = "Undefined";
    /**
     * A new event has started
     *
     * @generated from protobuf enum value: Start = 1;
     */
    EventOperation_EventOperationType[EventOperation_EventOperationType["Start"] = 1] = "Start";
    /**
     * An existing ongoing event has been updated by extending the end time.
     *
     * @generated from protobuf enum value: Extend = 2;
     */
    EventOperation_EventOperationType[EventOperation_EventOperationType["Extend"] = 2] = "Extend";
    /**
     * An event has completed / is no longer active.
     *
     * @generated from protobuf enum value: Complete = 3;
     */
    EventOperation_EventOperationType[EventOperation_EventOperationType["Complete"] = 3] = "Complete";
    /**
     * An existing event has been removed.
     *
     * @generated from protobuf enum value: Remove = 4;
     */
    EventOperation_EventOperationType[EventOperation_EventOperationType["Remove"] = 4] = "Remove";
    /**
     * An existing event has been updated in some way, e.g. start or end time.
     *
     * @generated from protobuf enum value: Update = 5;
     */
    EventOperation_EventOperationType[EventOperation_EventOperationType["Update"] = 5] = "Update";
    /**
     * Data other than event start/end, etc updated
     *
     * @generated from protobuf enum value: MetadataUpdate = 6;
     */
    EventOperation_EventOperationType[EventOperation_EventOperationType["MetadataUpdate"] = 6] = "MetadataUpdate";
    /**
     * An event was newly added
     *
     * @generated from protobuf enum value: Add = 7;
     */
    EventOperation_EventOperationType[EventOperation_EventOperationType["Add"] = 7] = "Add";
})(EventOperation_EventOperationType || (EventOperation_EventOperationType = {}));
/**
 * @generated from protobuf enum aware.EventConstraintSource
 */
export var EventConstraintSource;
(function (EventConstraintSource) {
    /**
     * @generated from protobuf enum value: UnspecifiedEventConstraintSource = 0;
     */
    EventConstraintSource[EventConstraintSource["UnspecifiedEventConstraintSource"] = 0] = "UnspecifiedEventConstraintSource";
    /**
     * @generated from protobuf enum value: Default = 1;
     */
    EventConstraintSource[EventConstraintSource["Default"] = 1] = "Default";
    /**
     * @generated from protobuf enum value: Inferred = 2;
     */
    EventConstraintSource[EventConstraintSource["Inferred"] = 2] = "Inferred";
    /**
     * @generated from protobuf enum value: UserInteraction = 3;
     */
    EventConstraintSource[EventConstraintSource["UserInteraction"] = 3] = "UserInteraction";
    /**
     * @generated from protobuf enum value: Calendar = 4;
     */
    EventConstraintSource[EventConstraintSource["Calendar"] = 4] = "Calendar";
})(EventConstraintSource || (EventConstraintSource = {}));
/**
 * @generated from protobuf enum aware.AttendanceType
 */
export var AttendanceType;
(function (AttendanceType) {
    /**
     * @generated from protobuf enum value: UnspecifiedAttendanceType = 0;
     */
    AttendanceType[AttendanceType["UnspecifiedAttendanceType"] = 0] = "UnspecifiedAttendanceType";
    /**
     * @generated from protobuf enum value: Accepted = 1;
     */
    AttendanceType[AttendanceType["Accepted"] = 1] = "Accepted";
    /**
     * @generated from protobuf enum value: Declined = 2;
     */
    AttendanceType[AttendanceType["Declined"] = 2] = "Declined";
    /**
     * @generated from protobuf enum value: Undecided = 3;
     */
    AttendanceType[AttendanceType["Undecided"] = 3] = "Undecided";
})(AttendanceType || (AttendanceType = {}));
/**
 * @generated from protobuf enum aware.CalendarResponseStatus
 */
export var CalendarResponseStatus;
(function (CalendarResponseStatus) {
    /**
     * Default case for unknown or unspecified statuses.
     *
     * @generated from protobuf enum value: UNKNOWN_CALENDAR_RESPONSE_STATUS = 0;
     */
    CalendarResponseStatus[CalendarResponseStatus["UNKNOWN_CALENDAR_RESPONSE_STATUS"] = 0] = "UNKNOWN_CALENDAR_RESPONSE_STATUS";
    /**
     * The attendee has not responded to the invitation.
     *
     * @generated from protobuf enum value: NEEDS_ACTION = 1;
     */
    CalendarResponseStatus[CalendarResponseStatus["NEEDS_ACTION"] = 1] = "NEEDS_ACTION";
    /**
     * The attendee has declined the invitation.
     *
     * @generated from protobuf enum value: DECLINED = 2;
     */
    CalendarResponseStatus[CalendarResponseStatus["DECLINED"] = 2] = "DECLINED";
    /**
     * The attendee has tentatively accepted the invitation.
     *
     * @generated from protobuf enum value: TENTATIVE = 3;
     */
    CalendarResponseStatus[CalendarResponseStatus["TENTATIVE"] = 3] = "TENTATIVE";
    /**
     * The attendee has accepted the invitation.
     *
     * @generated from protobuf enum value: ACCEPTED = 4;
     */
    CalendarResponseStatus[CalendarResponseStatus["ACCEPTED"] = 4] = "ACCEPTED";
})(CalendarResponseStatus || (CalendarResponseStatus = {}));
/**
 * @generated from protobuf enum aware.CalendarEventType
 */
export var CalendarEventType;
(function (CalendarEventType) {
    /**
     * @generated from protobuf enum value: UnknownCalendarEventType = 0;
     */
    CalendarEventType[CalendarEventType["UnknownCalendarEventType"] = 0] = "UnknownCalendarEventType";
    /**
     * @generated from protobuf enum value: PhoneCall = 1;
     */
    CalendarEventType[CalendarEventType["PhoneCall"] = 1] = "PhoneCall";
    /**
     * @generated from protobuf enum value: VideoMeeting = 2;
     */
    CalendarEventType[CalendarEventType["VideoMeeting"] = 2] = "VideoMeeting";
    /**
     * @generated from protobuf enum value: OnSite = 3;
     */
    CalendarEventType[CalendarEventType["OnSite"] = 3] = "OnSite";
    /**
     * @generated from protobuf enum value: Reminder = 4;
     */
    CalendarEventType[CalendarEventType["Reminder"] = 4] = "Reminder";
})(CalendarEventType || (CalendarEventType = {}));
/**
 * Activity Statistic Protos
 *
 * @generated from protobuf enum aware.TimeBinGranularity
 */
export var TimeBinGranularity;
(function (TimeBinGranularity) {
    /**
     * Default, indicates an issue or unset state
     *
     * @generated from protobuf enum value: GRANULARITY_UNSPECIFIED = 0;
     */
    TimeBinGranularity[TimeBinGranularity["GRANULARITY_UNSPECIFIED"] = 0] = "GRANULARITY_UNSPECIFIED";
    /**
     * 24 bins per day (each 3600s)
     *
     * @generated from protobuf enum value: GRANULARITY_HOURLY = 1;
     */
    TimeBinGranularity[TimeBinGranularity["GRANULARITY_HOURLY"] = 1] = "GRANULARITY_HOURLY";
    /**
     * 48 bins per day (each 1800s)
     *
     * @generated from protobuf enum value: GRANULARITY_THIRTY_MINUTE = 2;
     */
    TimeBinGranularity[TimeBinGranularity["GRANULARITY_THIRTY_MINUTE"] = 2] = "GRANULARITY_THIRTY_MINUTE";
    /**
     * 96 bins per day (each 900s)
     *
     * @generated from protobuf enum value: GRANULARITY_FIFTEEN_MINUTE = 3;
     */
    TimeBinGranularity[TimeBinGranularity["GRANULARITY_FIFTEEN_MINUTE"] = 3] = "GRANULARITY_FIFTEEN_MINUTE";
    /**
     * 144 bins per day (each 600s)
     *
     * @generated from protobuf enum value: GRANULARITY_TEN_MINUTE = 4;
     */
    TimeBinGranularity[TimeBinGranularity["GRANULARITY_TEN_MINUTE"] = 4] = "GRANULARITY_TEN_MINUTE";
    /**
     * 288 bins per day (each 300s)
     *
     * @generated from protobuf enum value: GRANULARITY_FIVE_MINUTE = 5;
     */
    TimeBinGranularity[TimeBinGranularity["GRANULARITY_FIVE_MINUTE"] = 5] = "GRANULARITY_FIVE_MINUTE";
    /**
     * 1440 bins per day (each 60s)
     *
     * @generated from protobuf enum value: GRANULARITY_MINUTE = 6;
     */
    TimeBinGranularity[TimeBinGranularity["GRANULARITY_MINUTE"] = 6] = "GRANULARITY_MINUTE";
})(TimeBinGranularity || (TimeBinGranularity = {}));
// @generated message type with reflection information, may provide speed optimized methods
class Event$Type extends MessageType {
    constructor() {
        super("aware.Event", [
            { no: 1, name: "start_date", kind: "message", T: () => Timestamp },
            { no: 2, name: "end_date", kind: "message", T: () => Timestamp },
            { no: 3, name: "event_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "geolocation", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Geolocation },
            { no: 5, name: "participant_user_uids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "event_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "activity_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "owner_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "event_type", kind: "enum", T: () => ["aware.Event.EventType", Event_EventType] },
            { no: 10, name: "transit_mode", kind: "enum", T: () => ["aware.TransitMode", TransitMode] },
            { no: 11, name: "main_event_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "calendar_event", kind: "message", T: () => CalendarEvent },
            { no: 101, name: "event_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 102, name: "aware_space_location", kind: "message", T: () => AwareSpaceLocation },
            { no: 103, name: "place_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 107, name: "end_place_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 104, name: "reminders", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ScheduleReminder },
            { no: 105, name: "route_polyline", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 106, name: "matched_schedule_event_uids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 108, name: "attendee_person_uids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 109, name: "data_contexts", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["aware.DataContext", DataContext] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.Event
 */
export const Event = new Event$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventOperation$Type extends MessageType {
    constructor() {
        super("aware.EventOperation", [
            { no: 1, name: "event_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "operation", kind: "enum", T: () => ["aware.EventOperation.EventOperationType", EventOperation_EventOperationType] },
            { no: 3, name: "event", kind: "message", T: () => Event },
            { no: 4, name: "entry_stamp", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.EventOperation
 */
export const EventOperation = new EventOperation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserSchedule$Type extends MessageType {
    constructor() {
        super("aware.UserSchedule", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "main_events", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => MainEvent } },
            { no: 3, name: "places", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Place } },
            { no: 100, name: "timestamp_generated", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserSchedule
 */
export const UserSchedule = new UserSchedule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransitStatus$Type extends MessageType {
    constructor() {
        super("aware.TransitStatus", [
            { no: 1, name: "main_event_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "transit_event_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "transit_mode", kind: "enum", T: () => ["aware.TransitMode", TransitMode] },
            { no: 102, name: "active_event_transit_progress", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 103, name: "expected_event_transit_progress", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 104, name: "expected_arrival_time_offset_minutes", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.TransitStatus
 */
export const TransitStatus = new TransitStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserScheduleStatus$Type extends MessageType {
    constructor() {
        super("aware.UserScheduleStatus", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "schedule_timestamp", kind: "message", T: () => Timestamp },
            { no: 3, name: "status_timestamp", kind: "message", T: () => Timestamp },
            { no: 4, name: "active_main_event_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "status", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TransitStatus }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserScheduleStatus
 */
export const UserScheduleStatus = new UserScheduleStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MainEvent$Type extends MessageType {
    constructor() {
        super("aware.MainEvent", [
            { no: 1, name: "event", kind: "message", T: () => Event },
            { no: 2, name: "event_constraints", kind: "message", T: () => EventConstraints },
            { no: 3, name: "options", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EventSequenceOption }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.MainEvent
 */
export const MainEvent = new MainEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventConstraints$Type extends MessageType {
    constructor() {
        super("aware.EventConstraints", [
            { no: 1, name: "event_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "time_last_updated", kind: "message", T: () => Timestamp },
            { no: 4, name: "prep_duration_mins", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "prep_duration_source", kind: "enum", T: () => ["aware.EventConstraintSource", EventConstraintSource] },
            { no: 12, name: "early_arrival_duration_mins", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "early_arrival_duration_source", kind: "enum", T: () => ["aware.EventConstraintSource", EventConstraintSource] },
            { no: 6, name: "transit_mode", kind: "enum", T: () => ["aware.TransitMode", TransitMode] },
            { no: 7, name: "transit_mode_source", kind: "enum", T: () => ["aware.EventConstraintSource", EventConstraintSource] },
            { no: 8, name: "attendance_type", kind: "enum", T: () => ["aware.AttendanceType", AttendanceType] },
            { no: 9, name: "attendance_source", kind: "enum", T: () => ["aware.EventConstraintSource", EventConstraintSource] },
            { no: 10, name: "pre_place_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "pre_place_uid_source", kind: "enum", T: () => ["aware.EventConstraintSource", EventConstraintSource] },
            { no: 100, name: "replace_existing_constraints", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.EventConstraints
 */
export const EventConstraints = new EventConstraints$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventSequenceOption$Type extends MessageType {
    constructor() {
        super("aware.EventSequenceOption", [
            { no: 1, name: "main_event_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "transit_mode", kind: "enum", T: () => ["aware.TransitMode", TransitMode] },
            { no: 3, name: "place_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "events", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Event }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.EventSequenceOption
 */
export const EventSequenceOption = new EventSequenceOption$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalendarEventListRequest$Type extends MessageType {
    constructor() {
        super("aware.CalendarEventListRequest", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "end_time", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.CalendarEventListRequest
 */
export const CalendarEventListRequest = new CalendarEventListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalendarStreamRequest$Type extends MessageType {
    constructor() {
        super("aware.CalendarStreamRequest", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "future_duration_mins", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "past_duration_mins", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.CalendarStreamRequest
 */
export const CalendarStreamRequest = new CalendarStreamRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalendarEventList$Type extends MessageType {
    constructor() {
        super("aware.CalendarEventList", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "events", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CalendarEvent }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.CalendarEventList
 */
export const CalendarEventList = new CalendarEventList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalendarAttendee$Type extends MessageType {
    constructor() {
        super("aware.CalendarAttendee", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "response_status", kind: "enum", T: () => ["aware.CalendarResponseStatus", CalendarResponseStatus] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.CalendarAttendee
 */
export const CalendarAttendee = new CalendarAttendee$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalendarEvent$Type extends MessageType {
    constructor() {
        super("aware.CalendarEvent", [
            { no: 1, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 2, name: "end_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "summary", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "calendar_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "calendar_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "recurring_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "attendance_type", kind: "enum", T: () => ["aware.AttendanceType", AttendanceType] },
            { no: 9, name: "all_day", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "calendar_event_type", kind: "enum", T: () => ["aware.CalendarEventType", CalendarEventType] },
            { no: 11, name: "function_args_json", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "json_data", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.CalendarEvent
 */
export const CalendarEvent = new CalendarEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventStatistics$Type extends MessageType {
    constructor() {
        super("aware.EventStatistics", [
            { no: 1, name: "event_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "locations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Geolocation },
            { no: 3, name: "places", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Place },
            { no: 4, name: "duration_mean_minutes", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "duration_stddev_minutes", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "arrival_offset_mean_minutes", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "arrival_offset_stddev_minutes", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 100, name: "all_events", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Event },
            { no: 101, name: "route_polyline", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.EventStatistics
 */
export const EventStatistics = new EventStatistics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserLocationStatistics$Type extends MessageType {
    constructor() {
        super("aware.UserLocationStatistics", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "visit_statistics", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EventStatistics },
            { no: 3, name: "movement_statistics", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EventStatistics },
            { no: 100, name: "timestamp_generated", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserLocationStatistics
 */
export const UserLocationStatistics = new UserLocationStatistics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleReminder$Type extends MessageType {
    constructor() {
        super("aware.ScheduleReminder", [
            { no: 1, name: "reminder_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "automation_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "reminder_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ScheduleReminder
 */
export const ScheduleReminder = new ScheduleReminder$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleReminderRequest$Type extends MessageType {
    constructor() {
        super("aware.ScheduleReminderRequest", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "reminder", kind: "message", T: () => ScheduleReminder },
            { no: 3, name: "event_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "start_date", kind: "message", T: () => Timestamp },
            { no: 5, name: "end_date", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ScheduleReminderRequest
 */
export const ScheduleReminderRequest = new ScheduleReminderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteReminderRequest$Type extends MessageType {
    constructor() {
        super("aware.DeleteReminderRequest", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "automation_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "reminder_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.DeleteReminderRequest
 */
export const DeleteReminderRequest = new DeleteReminderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScheduleReminderResponse$Type extends MessageType {
    constructor() {
        super("aware.ScheduleReminderResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message aware.ScheduleReminderResponse
 */
export const ScheduleReminderResponse = new ScheduleReminderResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DatasetContext$Type extends MessageType {
    constructor() {
        super("aware.DatasetContext", [
            { no: 1, name: "dataset_start_time", kind: "message", T: () => Timestamp },
            { no: 2, name: "dataset_end_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "total_days_in_dataset_span", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "dataset_timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.DatasetContext
 */
export const DatasetContext = new DatasetContext$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DailyActivityTimeOfDayHistogram$Type extends MessageType {
    constructor() {
        super("aware.DailyActivityTimeOfDayHistogram", [
            { no: 1, name: "filter_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "granularity", kind: "enum", T: () => ["aware.TimeBinGranularity", TimeBinGranularity] },
            { no: 3, name: "bin_active_seconds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 4 /*ScalarType.UINT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "total_days_activity_observed", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "first_observed_activity_time", kind: "message", T: () => Timestamp },
            { no: 6, name: "last_observed_activity_time", kind: "message", T: () => Timestamp },
            { no: 11, name: "dataset_context", kind: "message", T: () => DatasetContext }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.DailyActivityTimeOfDayHistogram
 */
export const DailyActivityTimeOfDayHistogram = new DailyActivityTimeOfDayHistogram$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WeeklyActivityTimeOfDayHistogram$Type extends MessageType {
    constructor() {
        super("aware.WeeklyActivityTimeOfDayHistogram", [
            { no: 1, name: "filter_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "granularity", kind: "enum", T: () => ["aware.TimeBinGranularity", TimeBinGranularity] },
            { no: 3, name: "day_specific_bin_counts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => WeeklyActivityTimeOfDayHistogram_DaySpecificBinCounts },
            { no: 5, name: "first_observed_activity_time", kind: "message", T: () => Timestamp },
            { no: 6, name: "last_observed_activity_time", kind: "message", T: () => Timestamp },
            { no: 11, name: "dataset_context", kind: "message", T: () => DatasetContext }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.WeeklyActivityTimeOfDayHistogram
 */
export const WeeklyActivityTimeOfDayHistogram = new WeeklyActivityTimeOfDayHistogram$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WeeklyActivityTimeOfDayHistogram_DaySpecificBinCounts$Type extends MessageType {
    constructor() {
        super("aware.WeeklyActivityTimeOfDayHistogram.DaySpecificBinCounts", [
            { no: 1, name: "bin_active_seconds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 4 /*ScalarType.UINT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "total_instances_observed", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "total_instances_of_dow_in_dataset_span", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.WeeklyActivityTimeOfDayHistogram.DaySpecificBinCounts
 */
export const WeeklyActivityTimeOfDayHistogram_DaySpecificBinCounts = new WeeklyActivityTimeOfDayHistogram_DaySpecificBinCounts$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivityStartTimeDistribution$Type extends MessageType {
    constructor() {
        super("aware.ActivityStartTimeDistribution", [
            { no: 1, name: "filter_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "granularity", kind: "enum", T: () => ["aware.TimeBinGranularity", TimeBinGranularity] },
            { no: 3, name: "day_of_week_counts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ActivityStartTimeDistribution_DayOfWeekStartTimeCounts },
            { no: 8, name: "dataset_context", kind: "message", T: () => DatasetContext }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ActivityStartTimeDistribution
 */
export const ActivityStartTimeDistribution = new ActivityStartTimeDistribution$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivityStartTimeDistribution_DayOfWeekStartTimeCounts$Type extends MessageType {
    constructor() {
        super("aware.ActivityStartTimeDistribution.DayOfWeekStartTimeCounts", [
            { no: 1, name: "start_time_bin_counts", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 4 /*ScalarType.UINT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "total_activity_sessions_on_day", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ActivityStartTimeDistribution.DayOfWeekStartTimeCounts
 */
export const ActivityStartTimeDistribution_DayOfWeekStartTimeCounts = new ActivityStartTimeDistribution_DayOfWeekStartTimeCounts$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivityDurationDistribution$Type extends MessageType {
    constructor() {
        super("aware.ActivityDurationDistribution", [
            { no: 1, name: "filter_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "total_sessions_analyzed", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "min_observed_duration_seconds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "max_observed_duration_seconds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "q1_duration_seconds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "median_duration_seconds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "q3_duration_seconds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "lower_whisker_duration_seconds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "upper_whisker_duration_seconds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "outlier_duration_seconds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "mean_duration_seconds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "std_dev_duration_seconds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "duration_histogram", kind: "message", T: () => ActivityDurationDistribution_DurationHistogram },
            { no: 18, name: "dataset_context", kind: "message", T: () => DatasetContext }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ActivityDurationDistribution
 */
export const ActivityDurationDistribution = new ActivityDurationDistribution$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivityDurationDistribution_DurationHistogram$Type extends MessageType {
    constructor() {
        super("aware.ActivityDurationDistribution.DurationHistogram", [
            { no: 1, name: "bin_upper_bounds_seconds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "bin_counts", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 4 /*ScalarType.UINT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ActivityDurationDistribution.DurationHistogram
 */
export const ActivityDurationDistribution_DurationHistogram = new ActivityDurationDistribution_DurationHistogram$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivityIntervalDistribution$Type extends MessageType {
    constructor() {
        super("aware.ActivityIntervalDistribution", [
            { no: 1, name: "previous_filter_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "next_filter_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "total_intervals_analyzed", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "min_observed_interval_seconds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "max_observed_interval_seconds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "q1_interval_seconds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "median_interval_seconds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "q3_interval_seconds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "lower_whisker_interval_seconds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "upper_whisker_interval_seconds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "outlier_interval_seconds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "mean_interval_seconds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "std_dev_interval_seconds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 14, name: "interval_histogram", kind: "message", T: () => ActivityIntervalDistribution_IntervalHistogram },
            { no: 19, name: "dataset_context", kind: "message", T: () => DatasetContext }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ActivityIntervalDistribution
 */
export const ActivityIntervalDistribution = new ActivityIntervalDistribution$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivityIntervalDistribution_IntervalHistogram$Type extends MessageType {
    constructor() {
        super("aware.ActivityIntervalDistribution.IntervalHistogram", [
            { no: 1, name: "bin_upper_bounds_seconds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "bin_counts", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 4 /*ScalarType.UINT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ActivityIntervalDistribution.IntervalHistogram
 */
export const ActivityIntervalDistribution_IntervalHistogram = new ActivityIntervalDistribution_IntervalHistogram$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserActivityStatistics$Type extends MessageType {
    constructor() {
        super("aware.UserActivityStatistics", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "filter_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "daily_activity_histogram", kind: "message", T: () => DailyActivityTimeOfDayHistogram },
            { no: 4, name: "weekly_activity_histogram", kind: "message", T: () => WeeklyActivityTimeOfDayHistogram },
            { no: 5, name: "activity_start_time_distribution", kind: "message", T: () => ActivityStartTimeDistribution },
            { no: 6, name: "activity_duration_distribution", kind: "message", T: () => ActivityDurationDistribution },
            { no: 7, name: "activity_interval_distribution", kind: "message", T: () => ActivityIntervalDistribution },
            { no: 100, name: "timestamp_generated", kind: "message", T: () => Timestamp },
            { no: 101, name: "all_events", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Event }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserActivityStatistics
 */
export const UserActivityStatistics = new UserActivityStatistics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserActivityStatisticsList$Type extends MessageType {
    constructor() {
        super("aware.UserActivityStatisticsList", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "activity_statistics", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => UserActivityStatistics } },
            { no: 3, name: "person_statistics", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => UserActivityStatistics } },
            { no: 4, name: "place_statistics", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => UserActivityStatistics } },
            { no: 5, name: "route_statistics", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => UserActivityStatistics } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserActivityStatisticsList
 */
export const UserActivityStatisticsList = new UserActivityStatisticsList$Type();
/**
 * @generated ServiceType for protobuf service aware.CalendarService
 */
export const CalendarService = new ServiceType("aware.CalendarService", [
    { name: "getEvents", options: {}, I: CalendarEventListRequest, O: CalendarEventList },
    { name: "streamEvents", serverStreaming: true, options: {}, I: CalendarStreamRequest, O: CalendarEventList }
]);
